<template>	
	<div class="knd-dropdown-wrapper">
		<div class="knd-dropdown" @click="dropdownClicked()" ref="knd-dropdown">
			<div class="knd-dropdown-text" v-html="dropdowntext"></div>
			<img 
				class="knd-select-icon visible" 
				ref="knd-select-icon-start"
				:src="require('@/assets/img/arrow-down.svg')" 
				alt="" />
			<img 
				class="knd-select-icon" 
				ref="knd-select-icon-end"
				:src="require('@/assets/img/arrow-down-blue.svg')" 
				alt="" />
		</div>

		<div class="knd-dropdown-options" ref="knd-dropdown-options">
			<div
				v-for="(option, index) in data" 
				:key="'option-' + index"
				class="knd-dropdown-option"
				@click="optionClicked(option, index)">
				<div class="dropdown-index">{{ index + 1 }}</div>
				<div class="dropdown-name">{{ option[this.name] }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import './dropdown.scss';

	export default {
		name: 'Dropdown',
		props: ['data', 'name'],
		computed: {
		},
		data: function() {
			return {
				// data: this.$store.state.data,
				dropdowntext: "Ik zit bij..."
			}
		},
		mounted() {
		},
		methods: {
			dropdownClicked() {
				this.$refs['knd-dropdown'].classList.toggle('clicked');
				this.$refs['knd-dropdown-options'].classList.toggle('visible');
			},

			optionClicked(value, index) {
				this.$emit('gekozen', value);

				this.$refs['knd-dropdown'].classList.toggle('clicked');
				this.$refs['knd-dropdown'].classList.add('chosen');
				this.$refs['knd-dropdown-options'].classList.toggle('visible');
				this.$refs['knd-select-icon-start'].classList.remove('visible');
				this.$refs['knd-select-icon-end'].classList.add('visible');

				this.dropdowntext = '<div class="dropdown-index">'+ (index + 1) + '</div><div class="dropdown-name">' + value[this.name] + '</div>'
			}
		}
	}
</script>